import React from "react"
import { Button } from "react-bootstrap";

export default function StepButton(props) {
    return (
        <Button
            onClick={() => props.setCurrentStep(props.step)}
            className="w-50"
            disabled={props.disabled}
            >
            Go
        </Button>
    )
}